import { request } from "@/utils/requestUtils";
import type { Page } from "@/utils/requestUtils";
import type { Address } from "./type";
export async function getAddressList(data: any) {
  return request<Page<Address>>({
    service: "oam-admin",
    url: "/address/list",
    method: "POST",
    data,
  });
}

export async function createAddress(data: any) {
  return request({
    service: "oam-admin",
    url: "/address/save",
    method: "POST",
    data,
  });
}

export async function deleteAddress(id: number) {
  return request({
    service: "oam-admin",
    url: "/address/delete",
    method: "POST",
    data: { id },
  });
}
